exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mentorConnectImg--i0_-S {\n  max-height: 200px;\n  display: block;\n  margin: auto;\n}\n\n", ""]);

// exports
exports.locals = {
	"mentorConnectImg": "mentorConnectImg--i0_-S"
};